import React from "react";
import { useLanguage } from "../config/LanguageContext";
import { useNavigate } from "react-router-dom";

function IndustryDiscover() {
  const { currentLanguage, translations } = useLanguage();
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/bookdemo");
  };

  const t = translations.discover[currentLanguage];

  return (
    <div className="discover-container">
      <h2>{t.header}</h2>
      <p className="secondary">{t.subheading}</p>
      <button className="cta-button-secondary-large" onClick={handleBookDemoClick}>
        {t.ctaButton}
      </button>
    </div>
  );
}

export default IndustryDiscover;
